// components/ClienteSearch.js
import React from 'react';

const ClienteSearch = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
  handleReset,
  searchResults,
  handleSelectCliente
}) => (
  <div className="mb-6">
    <div className="ui-card-soft rounded-2xl p-4 sm:p-5">
      <div className="flex flex-col gap-3 md:flex-row md:items-end">
        <div className="flex-1">
          <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.16em] text-slate-600">
            Buscar cliente (DNI, nombre o apellido)
          </label>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200"
          placeholder="Ingrese DNI, Nombre o Apellido"
          autoComplete="off"
          inputMode="text"
          style={{ textTransform: 'uppercase' }}
        />
      </div>
        <div className="flex gap-2">
          <button
            onClick={handleSearch}
            className="w-full rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-red-700 md:w-auto"
          >
            BUSCAR
          </button>
          <button
            onClick={handleReset}
            className="w-full rounded-xl bg-slate-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-700 md:w-auto"
          >
            LIMPIAR
          </button>
        </div>
      </div>
    </div>

    {searchResults.length > 0 && (
      <div className="mt-4">
        <h3 className="mb-2 text-sm font-semibold uppercase tracking-[0.16em] text-slate-500">Resultados de búsqueda</h3>
        <div className="max-h-60 overflow-y-auto rounded-2xl border border-slate-200 bg-white p-2 sm:p-3">
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-slate-200 text-left text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
                <th className="px-3 py-2">DNI</th>
                <th className="px-3 py-2">NOMBRE</th>
                <th className="px-3 py-2">APELLIDO</th>
                <th className="px-3 py-2">ACCIÓN</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.map((cliente) => (
                <tr key={cliente.idUsuario} className="border-b border-slate-100 text-sm last:border-b-0 hover:bg-slate-50">
                  <td className="px-3 py-2 text-slate-700">{cliente.dni}</td>
                  <td className="px-3 py-2 text-slate-700">{cliente.nombre}</td>
                  <td className="px-3 py-2 text-slate-700">{cliente.apellidoPaterno} {cliente.apellidoMaterno}</td>
                  <td className="px-3 py-2">
                    <button
                      onClick={() => handleSelectCliente(cliente)}
                      className="rounded-lg bg-red-600 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-red-700"
                    >
                      SELECCIONAR
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
);

export default ClienteSearch;
